export const TAPBAR_MOBILE_ID = 'tapbar-mobile';
export const TAPBAR_MOBILE_HEIGHT_CSS_VAR = '--tap-mobile-height';
